import GeneralForm from './GeneralForm';

export default GeneralForm;